import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export type MetaSlice = {
	ssrStartAt?: string
	ssrEndAt?: string
	hydrateAt?: string
	renderAt?: string
	effectAt?: string
	mode: 'app' | 'ssr' | 'lib'
	client: boolean
	mobile: boolean
	reallyMobile: boolean
	timzeoneOffset: number
	build: 'production' | 'development'
}
export const defaultMetaSlice: MetaSlice = {
	mode: 'app',
	client: false,
	mobile: false,
	reallyMobile: false,
	timzeoneOffset: 0,
	build: process.env.NODE_ENV !== 'production' ? 'development' : 'production',
}

export const metaSlice = createSlice({
	name: 'meta',
	initialState: defaultMetaSlice,
	reducers: {
		metaSsrStart: (state, action: PayloadAction<string>) => {
			state.ssrStartAt = action.payload
			state.mode = 'ssr'
		},
		metaSsrEnd: (state, action: PayloadAction<string>) => {
			state.ssrEndAt = action.payload
			state.renderAt = action.payload
			state.mode = 'ssr'
		},
		metaSsrHydrate: (state, action: PayloadAction<string>) => {
			state.hydrateAt = action.payload
			state.mode = 'ssr'
			state.client = true
		},
		metaRender: (state, action: PayloadAction<[string, 'app' | 'lib']>) => {
			state.renderAt = action.payload[0]
			delete state.effectAt
			state.mode = action.payload[1]
			state.client = true
		},
		metaEffect: (state, action: PayloadAction<string>) => {
			if (state.effectAt) return
			state.effectAt = action.payload
		},
		metaSetMobile: (state, action: PayloadAction<boolean>) => {
			state.mobile = action.payload
		},
		metaSetReallyMobile: (state, action: PayloadAction<boolean>) => {
			state.reallyMobile = action.payload
		},
		metaSetTimezoneOffset: (state, action: PayloadAction<number>) => {
			state.timzeoneOffset = action.payload
		},
	},
	selectors: {
		getMetaMode: state => state.mode,
		getMetaRender: state => state.renderAt,
		isClient: state => state.client,
		isMobile: state => state.mobile,
		isReallyMobile: state => state.reallyMobile,
		getTimezoneOffset: state => state.timzeoneOffset,
		getBuild: state => state.build,
	},
})

export const {
	reducer: metaReducer,
	actions: {
		metaRender,
		metaSetMobile,
		metaSetReallyMobile,
		metaSsrEnd,
		metaSsrHydrate,
		metaSsrStart,
		metaEffect,
		metaSetTimezoneOffset,
	},
	selectors: {
		getMetaMode,
		getMetaRender,
		isClient,
		isMobile,
		isReallyMobile,
		getTimezoneOffset,
		getBuild,
	},
} = metaSlice
